export default __webpack_public_path__ + "static/media/rainbowRoom.bd31fc10.jpg";